import React from 'react'

const Footer = ({ copyright }) => {
  return (
    <div className="copyright-notice">
      {copyright}
    </div>
  )
}

export default Footer


// WEBPACK FOOTER //
// ./src/components/Footer.js